import React, { useEffect, useState } from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { useUI } from '../contexts/UIContext';
import StatsCard from '../components/dashboard/StatsCard';
import IncomeOverview from '../components/dashboard/IncomeOverview';
import TeamStats from '../components/dashboard/TeamStats';
import ActivityChart from '../components/dashboard/ActivityChart';
import ReferralBox from '../components/dashboard/ReferralBox';
import UserBox from '../components/dashboard/UserBox';
import { Wallet, Coins, UserPlus, CreditCard } from 'lucide-react';

const Dashboard = () => {
  const { userInfo, userId, account, shortenAddress, grichInvContract, loading } = useWeb3();
  const { showLoading, hideLoading } = useUI();
  const [teamStats, setTeamStats] = useState({ totalTeam: 0, teamBusiness: '0' });

  useEffect(() => {
    if (userId > 0 && grichInvContract) {
      loadTeamStats();
    }
  }, [userId, grichInvContract]);

  const loadTeamStats = async () => {
    try {
      showLoading('Loading team stats...');
      const stats = await grichInvContract.getUserTeamStats(userId);
      setTeamStats({
        totalTeam: parseInt(stats.totalTeamCount.toString()),
        teamBusiness: stats.totalTeamBusiness.toString()
      });
      hideLoading();
    } catch (error) {
      console.error('Error loading team stats:', error);
      hideLoading();
    }
  };

  return (
    <>
      <div className="welcome-message">
        <h1>Welcome to the <span className="highlight">Future</span> of Investment</h1>
        <p className="section-description">Powered by blockchain technology and AI-driven analysis</p>
      </div>

      {/* User Identification Box */}
      <UserBox 
        userId={userId} 
        wallet={account ? shortenAddress(account) : 'N/A'} 
      />

      <div className="dashboard-grid">
        {/* Stats Cards */}
        <StatsCard
          icon={<Wallet size={24} />}
          title="Your Investment"
          value={userInfo ? `${parseFloat(userInfo.totalDepositUSDT).toFixed(2)} USDT` : "0 USDT"}
        />

        <StatsCard
          icon={<Coins size={24} />}
          title="Token Claimed"
          value={userInfo ? `${parseFloat(userInfo.totalTokensClaimed).toFixed(2)} GRICH` : "0 GRICH"}
        />

        <StatsCard
          icon={<UserPlus size={24} />}
          title="Direct Referrals"
          value={userInfo ? userInfo.refCount.toString() : "0"}
        />

        <StatsCard
          icon={<CreditCard size={24} />}
          title="Topup Wallet"
          value={userInfo && userInfo.topupWallet ? `${parseFloat(userInfo.topupWallet).toFixed(2)} USDT` : "0 USDT"}
        />

        {/* Income Overview */}
        <IncomeOverview userInfo={userInfo} />

        {/* Team Stats */}
        <TeamStats 
          totalTeam={teamStats.totalTeam}
          teamBusiness={teamStats.teamBusiness}
        />

        {/* Activity Chart */}
        <ActivityChart />
      </div>

      {/* Referral Box */}
      <ReferralBox userId={userId} />
    </>
  );
};

export default Dashboard;
